export const version = "wallet/5.6.0";
//# sourceMappingURL=_version.js.map